import script from "./CategoryNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryNavigation.vue?vue&type=style&index=0&id=bbf24e3e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbf24e3e"]])

export default __exports__